/**
 * STINA GÖTEBORG — Homepage Enhancements v3
 * Animaciones de scroll con IntersectionObserver
 */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initScrollAnimations();
    enhanceSectionHeadings();
    enhanceProductCards();
  });

  /* ─────────────────────────────────────────────
     ANIMACIONES DE SCROLL
  ───────────────────────────────────────────── */
  function initScrollAnimations() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var cardSelector    = '.card-wrapper, .product-card, .collection-list__item';
    var headingSelector = '.featured-collection .title, .section-header__title, .collection__title, .collection-list__title';
    var blockSelector   = '.shopify-section .rte, [class*="review"], [class*="testimonial"]';

    // Tarjetas → fade up escalonado
    document.querySelectorAll(cardSelector).forEach(function (el) {
      if (!el.classList.contains('sg-animate')) {
        el.classList.add('sg-animate');
      }
    });

    // Títulos → desliza desde la izquierda
    document.querySelectorAll(headingSelector).forEach(function (el) {
      if (!el.classList.contains('sg-animate--left')) {
        el.classList.add('sg-animate--left');
      }
    });

    // Bloques de texto → fade puro
    document.querySelectorAll(blockSelector).forEach(function (el) {
      if (!el.classList.contains('sg-animate--fade')) {
        el.classList.add('sg-animate--fade');
      }
    });

    // IntersectionObserver
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sg-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.10, rootMargin: '0px 0px -30px 0px' }
    );

    document.querySelectorAll('.sg-animate, .sg-animate--left, .sg-animate--fade').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ─────────────────────────────────────────────
     LÍNEA DORADA bajo títulos de sección
  ───────────────────────────────────────────── */
  function enhanceSectionHeadings() {
    document.querySelectorAll('.featured-collection .title, .section-header__title').forEach(function (title) {
      if (title.parentElement && !title.parentElement.querySelector('.sg-title-line')) {
        var line = document.createElement('span');
        line.className = 'sg-title-line';
        line.setAttribute('aria-hidden', 'true');
        title.after(line);
      }
    });
  }

  /* ─────────────────────────────────────────────
     HOVER SUAVE en info de tarjetas
     + Imagen clickable en cards de Dawn y Stina
  ───────────────────────────────────────────── */
  function enhanceProductCards() {

    /* ── Hover suave en cards de Dawn ── */
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      var info = card.querySelector('.card__information');
      if (info) {
        card.addEventListener('mouseenter', function () {
          info.style.transition = 'transform 0.3s ease';
          info.style.transform  = 'translateY(-2px)';
        });
        card.addEventListener('mouseleave', function () {
          info.style.transform = 'translateY(0)';
        });
      }
    });

    /* ── Imágenes clickables — funciona con Dawn Y secciones Stina ──
       Busca cualquier contenedor de imagen de producto y le añade
       un handler de click directo que navega a la URL del producto.
       Esto evita problemas de z-index, overlays y eventos heredados. ── */

    /* Selectores de imagen: Dawn (.card__media) + Stina custom (.stina-cp__card-img-wrap, .scm__img-wrap) */
    var imgSelectors = [
      '.card__media',
      '.stina-cp__card-img-wrap',
      '.scm__img-wrap'
    ];

    imgSelectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(imgWrap) {
        /* Si ya está dentro de un <a> con href de producto, no hacer nada */
        if (imgWrap.closest('a[href*="/products/"]')) return;

        /* Buscar el link del producto en el contenedor padre de la card */
        var card = imgWrap.closest('li, article, .card-wrapper');
        if (!card) return;
        var productLink = card.querySelector('a[href*="/products/"]');
        if (!productLink) return;

        var url = productLink.getAttribute('href');

        /* Cursor pointer para indicar que es clickable */
        imgWrap.style.cursor = 'pointer';

        /* Click handler directo — más fiable que envolver en <a> */
        imgWrap.addEventListener('click', function(e) {
          /* No interferir si ya hay un link dentro siendo clickado */
          if (e.target.closest('a')) return;
          window.location.href = url;
        });
      });
    });
  }

})();
